import {Spin} from 'antd';
import React from 'react';

import {CustomCard} from 'components/@common/widgets/custom-card';
import {UIBlocker} from 'components/ui-blocker';
import {getTaxForecastDataByRequestId} from 'pages/ais/submit-income-tax-forecast/api/thunks';
import {TaxForecastActionPanel} from 'pages/ais/submit-income-tax-forecast/ui/action-panel/tax-forecast-action-panel';
import {TaxForecastFilters} from 'pages/ais/submit-income-tax-forecast/ui/filters/tax-forecast-filters';
import {TaxForecastTable} from 'pages/ais/submit-income-tax-forecast/ui/table/tax-forecast-table';
import {useAppSelector} from 'store/config/hooks';
import {selectIsThunkPending, selectThunkError} from 'store/slices/loading-state-slice';

export const TaxForecastPage = () => {
    const isLoading = useAppSelector(st => selectIsThunkPending(st, getTaxForecastDataByRequestId.typePrefix));
    const loadError = useAppSelector(st => selectThunkError(
        st, getTaxForecastDataByRequestId.typePrefix,
    ));

    return (
        <div>
            <Spin
                spinning={isLoading}
                tip="Загрузка данных..."
            >
                <CustomCard
                    title="Запросы для обмена информацией по результатам прогноза налоговой базы
                     и суммы налога на прибыль"
                    accordionContent={<TaxForecastFilters />}
                    isAccordionContentVisibleByDefault
                >
                    <UIBlocker
                        thunkError={{
                            error: loadError,
                            verbose: true,
                        }}
                    >
                        <TaxForecastActionPanel />
                        <TaxForecastTable />
                    </UIBlocker>
                </CustomCard>
            </Spin>
        </div>
    );
};
